(function(angular){
    'use strict';
    var app = angular.module('enervee');
    
    app.factory('ChangePasswordService', [
        'UserApiConsumerService',
        function(
            UserApiConsumerService
        ) {
            var _pub = {};
            var _passwordChangeResponse = null;

            /**
             * Changes existing user's password.
             *
             * @param oldPassword: old password.
             * @param newPassword1: new password.
             * @param newPassword2: new password confirmation.
             * @returns {*}
             */
            _pub.changePassword = function(oldPassword, newPassword1, newPassword2) {
                var data = {
                    'old_password': oldPassword,
                    'new_password1': newPassword1,
                    'new_password2': newPassword2
                };

                return UserApiConsumerService.post('api/1.0/rest-auth/password/change/', data)
                    .then(
                        // success
                        function(response) {
                            _passwordChangeResponse = {
                                'success': true,
                                'message': response.success
                            };
                        },
                        // error
                        function(response) {
                            _passwordChangeResponse = {
                                'success': false, 
                                'error': response.data
                            };
                        }
                    );
            };
            
            _pub.getChangePasswordResponse = function(){
                return _passwordChangeResponse;
            };
            
            return _pub;
        }
    ]);
})(angular);